'use client'

import React, { useMemo } from 'react'
import { useTranslations } from 'next-intl'

import { exploreOtherLinksByDomain } from '@/src/constants/exploreOtherLinks'
import { domainCountry } from '@/src/constants/domain'
import { ExploreOtherLinks } from './exploreOtherLinks'

export const ExploreOtherLinksWrapper: React.FC = () => {
    const t = useTranslations('homePage.headings')
    const tLinks = useTranslations('homePage.exploreOtherLinksList')
    
    // Default to 'AE' if domainCountry is not found or fallback to empty array
    const linksData = useMemo(() => {
        const countryCode = domainCountry as keyof typeof exploreOtherLinksByDomain
        return exploreOtherLinksByDomain[countryCode] || exploreOtherLinksByDomain['AE'] || []
    }, [])

    const links = useMemo(() => {
        return linksData.map((link) => ({
            url: link.url,
            text: tLinks(link.key as any)
        }))
    }, [linksData, tLinks])

    if (!links || links.length === 0) {
        return null
    }

    return <ExploreOtherLinks title={t('exploreOtherLinks') || 'Explore other links'} links={links} />
}

export default ExploreOtherLinksWrapper
